// | ------------------------------------------------------------------------
// | Imports
// | ------------------------------------------------------------------------

//window.$ = window.jQuery = jQuery;
//window.jQuery = window.jQuery = jQuery;
global.$ = global.jQuery = require("jquery");

// Bootstrap ----------------------------------------------------------------

import "@popperjs/core"; // Popper is required for dropdowns, popovers and tooltips.
import {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  OffCanvas,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip,
} from "bootstrap";

// Bootstrap overrides, calls and template integration
import "./bootstrap/collapse";
import "./bootstrap/modals";
import "./bootstrap/offcanvas";
import "./bootstrap/popovers";
import "./bootstrap/tooltips";

// Imports used in shop components ------------------------------------------

//? https://kingsora.github.io/OverlayScrollbars/
import { OverlayScrollbars } from "overlayscrollbars"; // Used in /components/shop/productFilters

//? https://splidejs.com/
import Splide from "@splidejs/splide"; // Used in /components/shop/productGallery

//? https://github.com/biati-digital/glightbox
// import GLightbox from "glightbox/dist/js/glightbox.js"; // Used in /components/shop/productGallery

import fsLightbox from "fslightbox";

// Other imports ------------------------------------------------------------

//? https://github.com/michalsnik/aos
import AOS from "aos"; // Used in /components/animateOnScroll

//? https://simpleparallax.com/
import simpleParallax from "simple-parallax-js"; // Used in /components/parallaxSections

//? https://github.com/yowainwright/shav
import shave from "shave"; // Used in /components/ellipsis

import validate from "jquery-validation";

// | ------------------------------------------------------------------------
// | Components
// | ------------------------------------------------------------------------

// Cookie popup
//import './components/cookieConsent/cookieOptions';

// | Layout -----------------------------------------------------------------

import "./components/fixedHeader";

// | Navigation -------------------------------------------------------------

import "./components/mainNavigation";
import "./components/dropdownOnHover";

// | Content ----------------------------------------------------------------

import "./components/modernizr-webp"; // Allow background images to fallback to jpegs
import "./components/ellipsis"; // Allows us to restrict text content using ellipsis
import "./components/gallery";
import "./components/office-space";
//import "./components/propertyMap";

// | Animations -------------------------------------------------------------

import "./components/animateOnScroll"; // Animate elements on page scroll
import "./components/heroParallaxBlur"; // Parallax, blur and fade hero background image on scroll
import "./components/parallaxSections"; // Parallax backgrounds for page sections
import "./components/scrollLinks";

// | Shop specific ----------------------------------------------------------

//import "./components/shop/productFilters";
//import "./components/shop/productGallery";
//import "./components/shop/productGrid";
//import "./components/shop/quantityInputs";

// | ------------------------------------------------------------------------
// | Code
// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  const dateInput = document.getElementById("date");
  if (dateInput) {
    try {
      dateInput.addEventListener("click", () => {
        console.log("clicked");
        dateInput.showPicker();
      });
    } catch (err) {
      console.log(err);
    }
  }

  const collapseBtn = document.getElementById("menuCollapseBtn");
  const myCollapsible = document.getElementById("menuCollapse");

  if (collapseBtn) {
    myCollapsible.addEventListener("show.bs.collapse", (event) => {
      collapseBtn.innerHTML = "Hide Menu";
    });

    myCollapsible.addEventListener("hide.bs.collapse", (event) => {
      collapseBtn.innerHTML = "View Menu";
    });
  }
});
